<template>
  <div class="search">
    <i class="close el-icon-close" @click="$emit('searchClose')"></i>
    <div class="form el-icon-search">
      <form action="">
        <input placeholder="请输入搜索内容">
        <input type="submit" value="ENTER">
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search{
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: #222;
}
.search .close{
  position: absolute;
  top: 38px;
  right: 2.6%;
  cursor: pointer;
  transition: .3s;
  font-size: 30px;
  color: #fff;
}
.search .close:hover{
  color: #d00010;
}
.search .form{
  position: absolute;
  top: 50%;
  left: 2.6%;
  width: 94.8%;
  padding: 10px 0;
  border-bottom: 1px solid #515151;
  font-size: 30px;
}
.search .form::before{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.search .form input{
  text-align: center;
  outline: none;
  background-color: transparent;
  border: 0;
  width: 100%;
  font-size: 1.2em;
  color: #fff;
  padding: 0 3em 0 2em;
}
.search .form input[type='submit']{
  font-size: .8em;
  color: #555;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  text-align: center;
  cursor: pointer;
  padding: initial;
}
</style>
<style>
.search .form input{
  text-align: center;
}
.search .form input:focus{
  border: 0;
}
</style>

